import { Routes } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { NoContentComponent } from './no-content/no-content.component';
import { UserSettingsComponent } from './shared/user-settings/user-settings.component';

export const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    pathMatch: 'full',
  },
  {
    path: 'user-settings',
    component: UserSettingsComponent,
  },
  {
    path: '**',
    component: NoContentComponent,
  },
];
